<template>
  <div class="hw">
    <h1>{{ msg }}</h1>
    <el-button>默认按钮</el-button>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import { Button as ElButton } from "element-ui";
export default Vue.extend({
  name: "HelloWorld",
  components: { ElButton },
  props: {
    msg: { type: String, default: "Hello World" },
  },
});
</script>
<style lang="scss" scoped>
.hw {
  width: 100%;
  height: 100%;
  color: red;
}
</style>